import { TreeNode } from 'primeng/api';
import { FilterTypes } from '../../../models/filterEnums.model';
import { FilterCriteria } from '../shared/filter-criteria.model';

export class ListedUnlistedFilter extends FilterCriteria {
  public override title = 'Listed/Unlisted';
  public override type: FilterTypes = FilterTypes.ListedUnlisted;
  listingStatusesSelection: TreeNode[] = null;

  public override validate(): boolean {
    return this.listingStatusesSelection && this.listingStatusesSelection.length > 0;
  }

  public override toString(): string {
    const selection: string = this.listingStatusesSelection ? this.listingStatusesSelection.map((selection) => selection.label).join(', ') : '';
    return 'Listed/Unlisted: ' + selection;
  }
}
